import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useTranslation } from "react-i18next";
import UserViewForm from "./UserviewForm";

// Component for viewing user details
const UserViewMain = () => {
  const { t } = useTranslation(); // Hook for internationalization

  useEffect(() => {
    GridStack.init(); // Initialize GridStack (for grid layout)
  }, []);

  // Layout information for grid items
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t("View User Details")}
          fileName=""
          showmenu={true}
          showdownload={false}
          showIconsForback={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <UserViewForm />, // User details display form
    },
  ];
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
      <GridItem layoutData={layoutData} />{" "}
      {/* Render grid items based on layout data */}
    </div>
  );
};
export default UserViewMain;
